import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ItensService } from '../../../../../services/itens.service';
import { markFormGroupTouched } from '@utils';

@Component({
  selector: 'app-item-tabela-preco-detalhe',
  templateUrl: './item-tabela-preco-detalhe.component.html',
  styleUrls: ['./item-tabela-preco-detalhe.component.css']
})
export class ItemTabelaPrecoDetalheComponent implements OnInit {
  @Input() itemEdicao: FormControl;
  @Input() precisaoPreco = 2;
  @Input() somatorioMarkupSelecionado = 0;
  @Output() formFinished = new EventEmitter<object>();
  formItem: FormGroup;
  titulo = 'Adicionar';
  loading = [];


  constructor(
    private itensService: ItensService,
  ) { }

  ngOnInit() {
    this.montaFormItem();
    this.carregaItemEdicao(this.itemEdicao);
    this.watchCusto();
  }

  montaFormItem() {
    this.formItem = new FormGroup({
      id: new FormControl(null),
      produtoId: new FormControl(null, [Validators.required]),
      produtoNome: new FormControl(null, [Validators.required]),
      unidade: new FormControl(null, [Validators.required]),
      unidadeMedidaId: new FormControl(null, [Validators.required]),
      custo: new FormControl(null),
      preco: new FormControl(null, [Validators.required]),
    });
  }

  carregaItemEdicao(item) {
    if (!item) {
      return;
    }

    this.titulo = 'Editar';
    this.formItem.get('id').setValue(item.id);
    this.formItem.get('produtoId').setValue(item.produtoId);
    this.formItem.get('produtoNome').setValue(item.produtoNome);
    this.formItem.get('unidadeMedidaId').setValue(item.unidadeMedidaId);
    this.formItem.get('unidade').setValue(item.unidade);
    this.formItem.get('preco').setValue(item.preco);
    this.formItem.get('custo').setValue(item.custo);
  }

  private getItem(produtoId) {
    return new Promise((resolve, reject) => {
      const query =
        // tslint:disable-next-line: max-line-length
        `(${produtoId})?$select=id, nome, referenciaItem, precoSaida, custoCompra&$expand=unidadeMedida($select=id, unidade)`;
      this.itensService.getByOData(query).subscribe(res => {
        resolve(res);
      }, () => {
        resolve(null);
      });
    });
  }

  async produtoChanged(produtoId) {
    if (!produtoId) {
      this.montaFormItem();
      return;
    }

    this.loading['item'] = true;
    const item = await this.getItem(produtoId) as any;
    this.loading['item'] = false;
    if (!item) {
      return;
    }

    this.formItem.get('produtoNome').setValue(item.referenciaItem + ' - ' + item.nome);
    this.formItem.get('unidadeMedidaId').setValue(item.unidadeMedida.id);
    this.formItem.get('unidade').setValue(item.unidadeMedida.unidade);
    this.formItem.get('custo').setValue(item.custoCompra);
    this.formItem.get('preco').setValue(
      this.somatorioMarkupSelecionado > 0 && item.custoCompra > 0
        ? item.custoCompra / ((100 - this.somatorioMarkupSelecionado) / 100)
        : item.precoSaida
    );
  }

  salvarItem() {
    markFormGroupTouched(this.formItem);
    if (this.formItem.invalid) {
      return;
    }

    const retorno = this.formItem.getRawValue();
    this.formFinished.emit(retorno);
  }

  cancelar() {
    this.formFinished.emit(null);
  }

  watchCusto() {
    this.formItem.get('custo').valueChanges.subscribe(this.recalcularPreco.bind(this));
  }

  recalcularPreco(custo) {
    custo = custo ?? 0;
    this.formItem.get('preco').setValue(custo / ((100 - this.somatorioMarkupSelecionado) / 100), { emitEvent: false });
  }
}
